import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import ListaDeMonedasConstant from 'constants/listaDeMonedas'

// TODO > Consistenciar constantes
const MonedaDetraccionFormGroup = ({ iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-monedaDetraccion' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='monedaDetraccion'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-monedaDetraccion'
              disabled
              isInvalid={iTouched && iError}
            >
              <option value={ListaDeMonedasConstant.SOLES}>SOLES</option>
              <option value={ListaDeMonedasConstant.DOLARES}>DOLARES</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaDetraccionFormGroup)
